module.exports = __webpack_public_path__ + "img/郑州市-c.afe729c7.png";